// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"298":"330c5e1f","361":"65e0d7a1","617":"eff28e0e","665":"a6f62951"}[chunkId] + ".js";
};